export interface LegalEntity {
    accountClientAlias: string;
    ownerId: number;
    ownerVersion: number;
    parentOwnerId: number;
    active: boolean; // has legal entity been disabled
    legalType: LegalTypeEnum;
    firstName: string;
    lastName: string;
    middleName: string;
    countryCodeOfBirth: string;
    socialNumber: string;
    email: string;
    shortName: string;
    longName: string;
    countryOfDomicile: string;
    orgNumber: string;
    leiCode: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    addressCountryCode: string;
    correlationId: string;
    status?: OwnerStatus;
    version: number;
    metadata: {
        website?: string;
        includeInGlobalFilter?: boolean; // should legal entity be included in global filter
        countryCode?: string;
        logoUrl?: string; // used for displaying logo in the owner list
    };
    logoUrl?: string; // used for displaying logo in the owner list
    website?: string; // used for displaying logo in the owner list
    displayName: string;
}

export enum OwnerStatus {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    ALL = '' // used as initial value (ALL)
}

export enum LegalTypeEnum {
    PERSON = 'PERSON',
    ORGANISATION = 'ORGANISATION',
    UNKNOWN = 'UNKNOWN'
}

export function createOwner(params: Partial<LegalEntity>) {
    return {} as LegalEntity;
}
